"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LoadingIndicator;
var _react = _interopRequireWildcard(require("react"));
var _Avatar = require("./Avatar");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function LoadingIndicator(_ref) {
  let {
    messages = [],
    typingSpeed = 28
  } = _ref;
  const [index, setIndex] = (0, _react.useState)(0);
  const [visible, setVisible] = (0, _react.useState)('');
  const scrollRef = (0, _react.useRef)(null);
  const msg = messages[index] || '';
  (0, _react.useEffect)(() => {
    const el = scrollRef.current;
    if (!el) return;
    const rid = requestAnimationFrame(() => {
      el.scrollLeft = Math.max(0, el.scrollWidth - el.clientWidth);
    });
    return () => cancelAnimationFrame(rid);
  }, [visible]);
  (0, _react.useEffect)(() => {
    if (!messages.length) return;
    setVisible('');
    let charIdx = 0;
    const perChar = Math.max(8, typingSpeed);
    const pauseMs = 4000;
    let charTimer = null;
    let nextTimer = null;
    charTimer = setInterval(() => {
      charIdx += 1;
      if (charIdx >= msg.length) {
        clearInterval(charTimer);
        setVisible(msg);
        nextTimer = setTimeout(() => {
          setIndex(i => i < messages.length - 1 ? i + 1 : i);
        }, pauseMs);
        return;
      }
      setVisible(msg.slice(0, charIdx));
    }, perChar);
    return () => {
      clearInterval(charTimer);
      clearTimeout(nextTimer);
    };
  }, [index, messages, msg, typingSpeed]);
  return (0, _jsxRuntime.jsxs)("div", {
    className: "tw-flex tw-items-end tw-gap-2 tw-self-start",
    role: "status",
    "aria-live": "polite",
    children: [(0, _jsxRuntime.jsx)(_Avatar.AgentAvatar, {
      state: "thinking"
    }), (0, _jsxRuntime.jsxs)("div", {
      className: "tw-p-3 tw-rounded-bubble tw-bg-sa-asst-bg tw-border tw-border-sa-border-lt tw-min-w-[220px]",
      children: [(0, _jsxRuntime.jsxs)("div", {
        className: "tw-flex tw-flex-col tw-gap-1.5 tw-mb-2.5",
        children: [(0, _jsxRuntime.jsx)("div", {
          className: "tw-h-2.5 tw-rounded tw-bg-gradient-to-r tw-from-sa-border-lt tw-via-sa-border tw-to-sa-border-lt tw-animate-sa-shimmer tw-w-[90%]"
        }), (0, _jsxRuntime.jsx)("div", {
          className: "tw-h-2.5 tw-rounded tw-bg-gradient-to-r tw-from-sa-border-lt tw-via-sa-border tw-to-sa-border-lt tw-animate-sa-shimmer tw-w-[70%]"
        }), (0, _jsxRuntime.jsx)("div", {
          className: "tw-h-2.5 tw-rounded tw-bg-gradient-to-r tw-from-sa-border-lt tw-via-sa-border tw-to-sa-border-lt tw-animate-sa-shimmer tw-w-[50%]"
        })]
      }), (0, _jsxRuntime.jsxs)("div", {
        className: "tw-flex tw-items-center tw-gap-2 tw-text-xs tw-text-sa-text-sec tw-overflow-hidden",
        ref: scrollRef,
        children: [(0, _jsxRuntime.jsxs)("span", {
          className: "tw-flex tw-gap-[3px]",
          "aria-hidden": "true",
          children: [(0, _jsxRuntime.jsx)("span", {
            className: "tw-w-1.5 tw-h-1.5 tw-rounded-full tw-bg-sa-primary tw-animate-sa-bounce"
          }), (0, _jsxRuntime.jsx)("span", {
            className: "tw-w-1.5 tw-h-1.5 tw-rounded-full tw-bg-sa-primary tw-animate-sa-bounce",
            style: {
              animationDelay: '75ms'
            }
          }), (0, _jsxRuntime.jsx)("span", {
            className: "tw-w-1.5 tw-h-1.5 tw-rounded-full tw-bg-sa-primary tw-animate-sa-bounce",
            style: {
              animationDelay: '150ms'
            }
          })]
        }), (0, _jsxRuntime.jsx)("span", {
          children: visible
        })]
      })]
    })]
  });
}